import { Component, OnDestroy, OnInit } from '@angular/core';
import { FruHttpService } from '../../../../../services/fru-http.service';
import { StateRateDescription } from '../../../../../shared/state-rate-description.model';
import { Subscription } from 'rxjs';
import { StateService } from '../../../../../services/state.service';

@Component({
  selector: 'app-state-rate-info',
  templateUrl: './state-rate-info.component.html',
  styleUrls: ['./state-rate-info.component.scss']
})
export class StateRateInfoComponent implements OnInit, OnDestroy {
  initialState: string;
  hook: string;
  conventionalInfo: string;
  fhaInfo: string;
  vaInfo: string;
  stateRateDescription: StateRateDescription;
  private subscription: Subscription;

  constructor(
    private fruHttp: FruHttpService,
    private stateService: StateService
  ) { }

  ngOnInit(): void {
    this.subscription = this.stateService.stateAbbreviation$.subscribe((value) => {
      if (value && value !== this.initialState) {
        this.initialState = value;
        this.fruHttp.getStateRateDescription(this.initialState)
          .subscribe({
            next: (data) => {
              this.stateRateDescription = data;
              if (data.hook) {
                this.hook = `<p> ${data.hook} </p>`;
              }
              if (data.conventional_info) {
                this.conventionalInfo = `<b>${data.state} conventional mortgages: </b> ${data.conventional_info}`;
              }
              if (data.fha_info) {
                this.fhaInfo = `<b>${data.state} FHA loans: </b> ${data.fha_info}`;
              }
              if (data.va_info) {
                this.vaInfo = `<b>${data.state} VA loans: </b> ${data.va_info}`;
              }
            }
          });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
